<div>
  <h2>Session Settings</h2>
  <hr class="hr-line mt-lg">
  <div class="row form-group">
    <div class="col-sm-3 col-xs-12">
      <label>Session Timeout:</label>
      <select
        class="form-control"
        id="sessionExpiry"
        name="sessionExpiry"
        [(ngModel)]="currentExpirySetting"
        (change)="onSettingChange()"
        [disabled]="!currentExpirySetting">
        <option
          *ngFor="let option of expiryOptions"
          [ngValue]="option.backendValue">
          {{ option.displayValue }}
        </option>
      </select>
      <p *ngIf="!currentExpirySetting">Loading current setting...</p>
    </div>
  </div>
  <div class="row form-group">
    <div class="col-sm-8 col-xs-12">
      <div class="checkbox">
        <label>
          <input type="checkbox" id="unloggedTimeRecovery" name="unloggedTimeRecovery"
            [(ngModel)]="unloggedTimeRecovery" (change)="onRecoveryChange()"
            [disabled]="unloggedTimeRecovery === undefined">
          <strong>Recover unlogged patient time</strong>
        </label>
      </div>
      <p class="text-muted m0">
        When a session times out, a user logs out, or the browser closes while patient tabs have unlogged time,
        that time is saved as a draft. At the next login, the user must either log the time—with adjustments if
        needed—or discard it. Time is only billed once it is logged. Turning this setting off stops new drafts from
        being saved for this practice.
      </p>
    </div>
  </div>
  <hr class="hr-line mt-lg">
</div>
